import IssuesPage from './IssuesPage';

export default IssuesPage;
